<template>
  <v-dialog v-model="editingCustomer" width="600">
    <v-card>
      <v-card-title>
        <span v-if="value.id">Modifica cliente</span>
        <span v-if="!value.id">Nuovo cliente</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="9">
              <v-text-field
                ref="selectedCustomerName"
                v-model="value.name"
                label="Cognome e nome"
                v-bind:rules="[rules.required]"
              />
            </v-col>
            <v-col cols="3">
              <v-checkbox
                v-model="value.active"
                true-value="1"
                false-value="0"
                label="Attivo"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-select
                v-model="value.gender"
                v-bind:items="genderList"
                label="Sesso"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="value.birthday"
                label="Data di nascita"
                type="date"
              />
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="value.tax_code"
                label="Codice fiscale"
                v-bind:rules="[rules.taxCode]"
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="value.address"
            label="Indirizzo"
          />
          <v-row>
            <v-col cols="2">
              <v-text-field
                v-model="value.zip_code"
                label="CAP"
                v-bind:rules="[rules.number]"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="value.city"
                label="Città"
              />
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="value.province"
                v-bind:items="provinceList"
                label="Provincia"
              />
            </v-col>
          </v-row>
          <div class="caption">Contatti</div>
          <v-btn
            v-for="(contact, index) in contactList"
            v-bind:key="index"
            v-on:click="editContact(contact)"
            class="mr-2 primary"
            rounded
          >
            <v-icon small>{{ contact.icon }}</v-icon>
            <span class="ml-1">{{ contact.value }}</span>
          </v-btn>
          <v-btn
            v-on:click="newContact()"
            class="primary"
            rounded
          ><v-icon>mdi-plus</v-icon></v-btn>
        </v-form>

        <v-dialog v-model="editingContact" width="500">
          <v-card>
            <v-card-title>
              Modifica contatto
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-select
                    v-model="selectedContact.type"
                    v-bind:items="contacts_types"
                    label="Tipo"
                  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    ref="selectedContactValue"
                    v-if="selectedContact.type"
                    v-model="selectedContact.value"
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn class="primary" v-on:click="saveContact">Salva</v-btn>
              <v-btn class="primary" v-on:click="deleteContact" v-if="selectedContact.index !== -1">Elimina</v-btn>
              <v-btn class="primary" v-on:click="closeContact">Annulla</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn class="primary" v-on:click="saveCustomer">Salva</v-btn>
        <v-btn class="primary" v-on:click="closeCustomer">Annulla</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import server from '../mixins/server'
import utils from '../mixins/utils'
import contacts from '../mixins/contacts'

export default {
  name: 'CustomerDetails',

  mixins: [ server, utils, contacts ],

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    rules: {
      required: value => !!value || 'Valore richiesto.',
      number: value => !value || /^\d{5}$/.test(value) || 'Valore non valido.',
      taxCode: value => !value || /^[a-z]{6}[0-9]{2}[a-z][0-9]{2}[a-z][0-9]{3}[a-z]$/i.test(value) || 'Valore non valido.',
    },
    valid: false,
    selectedContact: {},
    genderList: [
      { text: 'Femmina', value: 'F' },
      { text: 'Maschio', value: 'M' },
      { text: 'Altro', value: 'A' },
    ],
    provinceList: [
      { text: 'Agrigento', value:'AG' },
      { text: 'Alessandria', value:'AL' },
      { text: 'Ancona', value:'AN' },
      { text: 'Aosta', value:'AO' },
      { text: 'Arezzo', value:'AR' },
      { text: 'Ascoli Piceno', value:'AP' },
      { text: 'Asti', value:'AT' },
      { text: 'Avellino', value:'AV' },
      { text: 'Bari', value:'BA' },
      { text: 'Barletta-Andria-Trani', value:'BT' },
      { text: 'Belluno', value:'BL' },
      { text: 'Benevento', value:'BN' },
      { text: 'Bergamo', value:'BG' },
      { text: 'Biella', value:'BI' },
      { text: 'Bologna', value:'BO' },
      { text: 'Bolzano', value:'BZ' },
      { text: 'Brescia', value:'BS' },
      { text: 'Brindisi', value:'BR' },
      { text: 'Cagliari', value:'CA' },
      { text: 'Caltanissetta', value:'CL' },
      { text: 'Campobasso', value:'CB' },
      { text: 'Carbonia-Iglesias', value:'CI' },
      { text: 'Caserta', value:'CE' },
      { text: 'Catania', value:'CT' },
      { text: 'Catanzaro', value:'CZ' },
      { text: 'Chieti', value:'CH' },
      { text: 'Como', value:'CO' },
      { text: 'Cosenza', value:'CS' },
      { text: 'Cremona', value:'CR' },
      { text: 'Crotone', value:'KR' },
      { text: 'Cuneo', value:'CN' },
      { text: 'Enna', value:'EN' },
      { text: 'Fermo', value:'FM' },
      { text: 'Ferrara', value:'FE' },
      { text: 'Firenze', value:'FI' },
      { text: 'Foggia', value:'FG' },
      { text: 'Forlì-Cesena', value:'FC' },
      { text: 'Frosinone', value:'FR' },
      { text: 'Genova', value:'GE' },
      { text: 'Gorizia', value:'GO' },
      { text: 'Grosseto', value:'GR' },
      { text: 'Imperia', value:'IM' },
      { text: 'Isernia', value:'IS' },
      { text: 'La Spezia', value:'SP' },
      { text: 'L\'Aquila', value:'AQ' },
      { text: 'Latina', value:'LT' },
      { text: 'Lecce', value:'LE' },
      { text: 'Lecco', value:'LC' },
      { text: 'Livorno', value:'LI' },
      { text: 'Lodi', value:'LO' },
      { text: 'Lucca', value:'LU' },
      { text: 'Macerata', value:'MC' },
      { text: 'Mantova', value:'MN' },
      { text: 'Massa-Carrara', value:'MS' },
      { text: 'Matera', value:'MT' },
      { text: 'Messina', value:'ME' },
      { text: 'Milano', value:'MI' },
      { text: 'Modena', value:'MO' },
      { text: 'Monza e della Brianza', value:'MB' },
      { text: 'Napoli', value:'NA' },
      { text: 'Novara', value:'NO' },
      { text: 'Nuoro', value:'NU' },
      { text: 'Olbia-Tempio', value:'OT' },
      { text: 'Oristano', value:'OR' },
      { text: 'Padova', value:'PD' },
      { text: 'Palermo', value:'PA' },
      { text: 'Parma', value:'PR' },
      { text: 'Pavia', value:'PV' },
      { text: 'Perugia', value:'PG' },
      { text: 'Pesaro e Urbino', value:'PU' },
      { text: 'Pescara', value:'PE' },
      { text: 'Piacenza', value:'PC' },
      { text: 'Pisa', value:'PI' },
      { text: 'Pistoia', value:'PT' },
      { text: 'Pordenone', value:'PN' },
      { text: 'Potenza', value:'PZ' },
      { text: 'Prato', value:'PO' },
      { text: 'Ragusa', value:'RG' },
      { text: 'Ravenna', value:'RA' },
      { text: 'Reggio Calabria', value:'RC' },
      { text: 'Reggio Emilia', value:'RE' },
      { text: 'Rieti', value:'RI' },
      { text: 'Rimini', value:'RN' },
      { text: 'Roma', value:'RM' },
      { text: 'Rovigo', value:'RO' },
      { text: 'Salerno', value:'SA' },
      { text: 'Medio Campidano', value:'VS' },
      { text: 'Sassari', value:'SS' },
      { text: 'Savona', value:'SV' },
      { text: 'Siena', value:'SI' },
      { text: 'Siracusa', value:'SR' },
      { text: 'Sondrio', value:'SO' },
      { text: 'Taranto', value:'TA' },
      { text: 'Teramo', value:'TE' },
      { text: 'Terni', value:'TR' },
      { text: 'Torino', value:'TO' },
      { text: 'Ogliastra', value:'OG' },
      { text: 'Trapani', value:'TP' },
      { text: 'Trento', value:'TN' },
      { text: 'Treviso', value:'TV' },
      { text: 'Trieste', value:'TS' },
      { text: 'Udine', value:'UD' },
      { text: 'Varese', value:'VA' },
      { text: 'Venezia', value:'VE' },
      { text: 'Verbano-Cusio-Ossola', value:'VB' },
      { text: 'Vercelli', value:'VC' },
      { text: 'Verona', value:'VR' },
      { text: 'Vibo Valentia', value:'VV' },
      { text: 'Vicenza', value:'VI' },
      { text: 'Viterbo', value:'VT' },
    ],
  }),

  watch: {
    editingCustomer: {
      handler (newValue) { newValue && this.utils_focusInput('selectedCustomerName', 200); }
    },
    editingContact: {
      handler (newValue) { newValue && this.utils_focusInput('selectedContactValue', 200); }
    },
  },

  computed: {
    editingCustomer: {
      get: function() { return 'id' in this.value; },
      set: function(value) { if (!value) this.closeCustomer(); },
    },
    editingContact: {
      get: function() { return 'type' in this.selectedContact; },
      set: function(value) { if (!value) this.selectedContact = {}; },
    },
    contactList: function() { return this.contacts_load(this.value.contacts); },
  },

  methods: {
    closeCustomer: function() { this.$emit('input', {}); },

    saveCustomer: function() {
      // Validate form first
      if (this.$refs.form.validate()) {
        const parameters = {
          url: `Customer/index/${this.value.id || 0}`,
          data: this.value,
          onSuccess: (data) => {
            // Return the new id
            this.$emit('input', { newId: (data && 'id' in data) ? data.id : this.value.id });
          }
        };

        if (this.value.id) {
          this.server_update(parameters);
        } else {
          this.server_save(parameters);
        }
      }
    },

    newContact: function() { this.selectedContact = { type: 'cellular', index: -1, value: '' }; },

    editContact: function(item) { this.selectedContact = Object.assign({}, item); },

    closeContact: function() { this.selectedContact = {}; },

    saveContact: function() {
      const contactList = this.contactList;

      if (this.selectedContact.index === -1)
        this.selectedContact.index = contactList.length;
      contactList[this.selectedContact.index] = this.selectedContact;

      this.value.contacts = this.contacts_save(contactList);
      this.closeContact();
    },

    deleteContact: function() {
      if (this.selectedContact.index !== -1) {
        const contactList = this.contactList;
        contactList.splice(this.selectedContact.index, 1);
        this.value.contacts = this.contacts_save(contactList);
      }

      this.closeContact();
    },
  }
}
</script>
